/** GST state codes (first 2 digits of GSTIN) → state name */
export const GST_STATE_NAMES: Record<string, string> = {
  '01': 'Jammu & Kashmir',
  '02': 'Himachal Pradesh',
  '03': 'Punjab',
  '04': 'Chandigarh',
  '05': 'Uttarakhand',
  '06': 'Haryana',
  '07': 'Delhi',
  '08': 'Rajasthan',
  '09': 'Uttar Pradesh',
  '10': 'Bihar',
  '11': 'Sikkim',
  '12': 'Arunachal Pradesh',
  '13': 'Nagaland',
  '14': 'Manipur',
  '15': 'Mizoram',
  '16': 'Tripura',
  '17': 'Meghalaya',
  '18': 'Assam',
  '19': 'West Bengal',
  '20': 'Jharkhand',
  '21': 'Odisha',
  '22': 'Chhattisgarh',
  '23': 'Madhya Pradesh',
  '24': 'Gujarat',
  '26': 'Dadra and Nagar Haveli and Daman and Diu',
  '27': 'Maharashtra',
  '28': 'Andhra Pradesh',
  '29': 'Karnataka',
  '30': 'Goa',
  '31': 'Lakshadweep',
  '32': 'Kerala',
  '33': 'Tamil Nadu',
  '34': 'Puducherry',
  '35': 'Andaman and Nicobar Islands',
  '36': 'Telangana',
  '37': 'Andhra Pradesh',
  '38': 'Ladakh',
};

export function gstStateCodeFromGstin(gstin?: string | null): string | null {
  if (!gstin || gstin.length < 2) return null;
  const code = gstin.trim().slice(0, 2);
  return /^\d{2}$/.test(code) ? code : null;
}

export function formatPlaceOfSupply(gstin?: string | null, fallbackState?: string | null): string | null {
  const code = gstStateCodeFromGstin(gstin);
  if (code) {
    const name = GST_STATE_NAMES[code] || fallbackState || 'India';
    return `${name} (${code})`;
  }
  if (fallbackState) return fallbackState;
  return null;
}

export function isInterStateSupply(
  supplierGstin?: string | null,
  recipientGstin?: string | null
): boolean {
  const from = gstStateCodeFromGstin(supplierGstin);
  const to = gstStateCodeFromGstin(recipientGstin);
  if (!from || !to) return true;
  return from !== to;
}
